export default "__VITE_ASSET__BGGPBXcT__"